import { gql } from 'apollo-boost'

const ME = gql`
  {
    me {
      id
      firstName
      email
      roles
      businessAccount
    }
  }
`

const ALL_FIELDS = gql`
{
  users {
    id
    email
    firstName
    lastName
    roles
  }
}
`

const GENERAL = gql`
  query User($id: ID!) {
    user(where: { id: $id }) {
      id
      email
      firstName
      lastName
      roles
    }
  }
`

const SELECT = gql`
{
  users {
    id
    email
    firstName
    lastName
    accounts {
      id
    }
  }
}
`

const PROFILE = gql`
{
  me {
    id
    email
    firstName
    lastName
  }
}
`

const BUSINESS = gql`
{
  me {
    id
    accounts(where: { type: BUSINESS }) {
      id
      name
      description
      cta
      url
      imageUrl
      geofenceLimit
      rewardLimit
    }
  }
}
`

const ACCOUNT_SELECT = gql`
{
  accounts {
    id
    name
    type
  }
}
`

const USER_BUSINESS = gql`
query User($id: ID!) {
  user(where: { id: $id }) {
    id
    accounts {
      id
      name
      description
      url
      cta
      imageUrl
      geofenceLimit
      rewardLimit
    }
  }
}
`

const LIMITS = gql`
{
  me {
    id
    accounts {
      id
      geofenceLimit
      rewardLimit
    }
  }
}
`

const users = {
  ME,
  ALL_FIELDS,
  GENERAL,
  SELECT,
  PROFILE,
  BUSINESS,
  ACCOUNT_SELECT,
  USER_BUSINESS,
  LIMITS,
}

export default users
